import { type FC } from 'react';

// MUI
import Typography from '@mui/material/Typography';

interface StyledLabelProps {
  label: string;
  sx?: React.CSSProperties;
}

const StyledLabel: FC<StyledLabelProps> = ({ label, sx }) => {
  return <Typography sx={{ mb: 2, ...sx }}>{label}</Typography>;
};

export default StyledLabel;
